export default class ProductModalGalleryContent {
    private currentScale = 1;
    private currentDeltaX = 0;
    private currentDeltaY = 0;

    private adjustScale = 1;
    private adjustDeltaX = 0;
    private adjustDeltaY = 0;

    public resetAdjust(): void {
        this.adjustScale = 1;
        this.adjustDeltaX = 0;
        this.adjustDeltaY = 0;
    }

    public shiftCurrentTransforms(scale: number, deltaX: number, deltaY: number): void {
        this.currentScale = this.adjustScale * scale;
        this.currentDeltaX = this.adjustDeltaX + (deltaX / this.currentScale);
        this.currentDeltaY = this.adjustDeltaY + (deltaY / this.currentScale);
    }

    public moveCurrentTransformsToAdjust(imageContainerWidth: number, imageContainerHeight: number): void {
        const changeScale = Math.max(this.currentScale, 1);
        const checkX = (((imageContainerWidth * changeScale) - imageContainerWidth) / 2) / changeScale;
        const checkY = (((imageContainerHeight * changeScale) - imageContainerHeight) / 2) / changeScale;

        if (this.currentDeltaX > checkX && this.currentDeltaX >= 0) {
            this.currentDeltaX = checkX;
        } else if (this.currentDeltaX < -checkX && this.currentDeltaX <= 0) {
            this.currentDeltaX = -checkX;
        }

        if (this.currentDeltaY > checkY && this.currentDeltaY >= 0) {
            this.currentDeltaY = checkY;
        } else if (this.currentDeltaY < -checkY && this.currentDeltaY <= 0) {
            this.currentDeltaY = -checkY;
        }

        this.adjustScale = this.currentScale;
        this.adjustDeltaX = this.currentDeltaX;
        this.adjustDeltaY = this.currentDeltaY;
    }

    public getImageTransforms(): string {
        return `scale(${this.adjustScale}) translate(${this.adjustDeltaX}px,${this.adjustDeltaY}px)`;
    }

    public getImageCurrentTransforms(): string {
        return `scale(${this.currentScale}) translate(${this.currentDeltaX}px,${this.currentDeltaY}px)`;
    }
}
